// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"114":"62246d5f","169":"7dfdb25e","663":"91b3e303"}[chunkId] + ".chunk.css";
};